<ng-template #accountManagerModalFormContent role="document" let-modal>

  <app-page-comp-header #pageHeader
    [showBottomBorder]="false"
    [title]="formTitle"
  >
  </app-page-comp-header>

  <form (ngSubmit)="accountManagerFormSubmitAttempt()" [formGroup]="accountManagerForm" class="tablelist-form" autocomplete="off">
    <div class="modal-body" id="accountManagerFormDetails">

      <div class="row">
        <div class="col-12 col-md-4">
          <label class="form-label">Photo</label>
          <div class="am-photo">
            @if(hasPhotoPreview) {
              <img class="am-photo-img" [src]="photoPreviewUrl" alt="Account manager photo" />
            } @else {
              <div class="am-photo-placeholder">
                <i class="ri-user-3-line"></i>
              </div>
            }
          </div>
          <div class="d-flex gap-2 mt-2">
            <label class="btn btn-soft-success btn-sm mb-0">
              Upload
              <input type="file" accept="image/png,image/jpeg,image/webp" hidden (change)="onPhotoSelected($event)" />
            </label>
            @if(hasPhotoPreview) {
              <button type="button" class="btn btn-soft-danger btn-sm" (click)="removePhoto()">Remove</button>
            }
          </div>
          <div class="form-text">PNG, JPEG or WebP. Max 2 MB.</div>
        </div>

        <div class="col-12 col-md-8">
          <div class="mb-3">
            <label class="form-label" for="am-name-field" [class.required]="true">Name</label>
            <input
              autocomplete="no-fill"
              class="form-control"
              data-lpignore="true"
              formControlName="name"
              id="am-name-field"
              [ngClass]="{ 'is-invalid': formSubmitted && formData['name'].errors }"
              placeholder=""
              type="text"
            />
            @if(formSubmitted && formData['name'].hasError('maxlength')) {
              <div class="invalid-feedback d-block">Maximum length of {{nameMaxLength}} characters has been exceeded</div>
            } @else if(formSubmitted && formData['name'].errors) {
              <div class="invalid-feedback d-block">A value is required</div>
            }
          </div>

          <div class="mb-3">
            <label class="form-label" for="am-email-field" [class.required]="true">Email</label>
            <input
              autocomplete="no-fill"
              class="form-control"
              data-lpignore="true"
              formControlName="email"
              id="am-email-field"
              [ngClass]="{ 'is-invalid': formSubmitted && formData['email'].errors }"
              placeholder=""
              type="email"
            />
            @if(formSubmitted && formData['email'].hasError('email')) {
              <div class="invalid-feedback d-block">Please enter a valid email address</div>
            } @else if(formSubmitted && formData['email'].hasError('maxlength')) {
              <div class="invalid-feedback d-block">Maximum length of {{emailMaxLength}} characters has been exceeded</div>
            } @else if(formSubmitted && formData['email'].errors) {
              <div class="invalid-feedback d-block">A value is required</div>
            }
          </div>

          <div class="mb-3">
            <label class="form-label" for="am-contact-field">Contact Number</label>
            <input
              autocomplete="no-fill"
              class="form-control"
              data-lpignore="true"
              formControlName="contactNumber"
              id="am-contact-field"
              [ngClass]="{ 'is-invalid': formSubmitted && formData['contactNumber'].errors }"
              placeholder=""
              type="text"
            />
            @if(formSubmitted && formData['contactNumber'].hasError('maxlength')) {
              <div class="invalid-feedback d-block">Maximum length of {{contactNumberMaxLength}} characters has been exceeded</div>
            }
          </div>

          <div class="form-check form-switch form-switch-md">
            <label class="form-check-label" for="am-active-field">Active</label>
            <input class="form-check-input" type="checkbox" role="switch" id="am-active-field" formControlName="active">
          </div>
        </div>
      </div>

    </div>

    <div class="modal-footer">
      <div class="col-12">
        <div class="row">
          <div class="col-12">
            <div class="hstack gap-2 justify-content-end">
              <button type="button" class="btn btn-light" data-bs-dismiss="modal" (click)="accountManagerFormCancel()">Close</button>
              <button type="submit" class="btn btn-success" id="add-btn-account-manager" [disabled]="!canSubmit">{{ saving ? 'Saving...' : 'Submit' }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>

  </form>

</ng-template>

<app-completed-modal-form #completedModalForm
  (modalClosed)="accountManagerCompletedModalHasBeenClosed()"
></app-completed-modal-form>
